import React, { Component } from 'react';
import withAppLayout from '../components/appLayout';
import Sidebar from '../components/home/sidebar';
import Section from '../components/home/section';
import MobileNav from '../components/home/mobile-nav';
import {
  SECTIONS,
  MOBILE_NAV_DATA,
  SIDEBAR_DATA_MOBILE,
  // SAVE_TAXES_PLAN_POINTS,
} from '../constants/homeConstants';
import cx from 'classnames';
import queryString from 'query-string';
import styles from '../styles/home/home.scss';
import { bucketLists } from '../constants/index';
// @ts-ignore
import { Router } from '../configs/routes';
import { handleTrack } from '../utils/trackActions';
import { Api } from '../api';

import ResourceList from '../components/homePage/resourceList';
import Featured from '../components/homePage/featured';
import WhyUsSection from '../components/homePage/whyUsSection';
import withCompareWidget from '../components/common/compareWidgetHOC';
import RequestCallback from '../components/singleFund/requestCallback';
import BannerOne from '../components/homePage/experimental/bannerOne';
import { VARIANT_VALUES } from '../constants/variantConstants';
import HomeSearch from '../components/home/homeSearch';
import TopPlanCards from '../components/homePage/experimental/topPlanCards';
import InvestFlowHandler from '../components/common/investFlowHandler';
import TopBlackBanner from '../components/homePage/experimental/topBlackBanner';
// import TopDeclarationBanner from '../components/homePage/experimental/topDeclarationBanner';
import NfoSection from '../components/homePage/nfoSection';
import { getFundDetailsGraphql } from '../utils/index';
import { nfoListing } from '../query/nfo';

const api = new Api();

interface State {
  'time-frame': string;
  'risk-return': string;
  explore: string;
  selectedFund: object | any;
  query: object | any;
  startFlow: boolean;
  taxBucket: any;
  nfos: any;
}

class HomeOld extends Component<any, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      'time-frame': 'ultra-short-term',
      'risk-return': 'moderate-risk',
      explore: 'elss-funds',
      startFlow: false,
      query: this.props.url.query || {},
      taxBucket: bucketLists[0],
      selectedFund: null,
      nfos: [],
    };
  }

  private trackingLabel: string = 'top_funds_button';

  public componentDidMount() {
    const { query } = this.props.url;
    this.handleQueryparams(query);
    this.getLiveNfos();
  }

  public async getLiveNfos() {
    const nfos = await getFundDetailsGraphql(nfoListing);
    this.setState({
      nfos: [
        ...nfos.data.getNfos.liveNfos,
        ...nfos.data.getNfos.upcomingNfos,
        ...nfos.data.getNfos.closedNfos,
      ],
    });
  }

  public UNSAFE_componentWillReceiveProps(nextProps: any) {
    const { query: oldQuery } = this.props.url;
    const { query } = nextProps.url;
    if (
      oldQuery.fundId !== query.fundId ||
      oldQuery.detailsSlug !== query.detailsSlug
    ) {
      this.setState({ query }, () => this.handleQueryparams(query));
    }
  }

  public async handleQueryparams(query: any) {
    if (query.fundId) {
      const fundDetails = await api.getFundDetails(query.fundId);
      if (fundDetails) {
        this.setState({
          selectedFund: {
            ...fundDetails,
            id: fundDetails.productId,
          },
          startFlow: true,
        });
      }
    }
  }

  public dismissModal = () => {
    Router.pushRoute(`/save`, '/save', { shallow: true });
  };

  public onTabClick = (e: any) => {
    e.preventDefault();
    const { key, value } = e.target.dataset;
    handleTrack({ label: `${this.trackingLabel}_tab_${key}`, obj: e.target });
    if (key && value) {
      this.setState({
        [key]: value,
      });
    }
  };

  public startInvestment = (selectedFund: any, id?: string) => {
    const { productId, fundName, fundType } = selectedFund;
    const { url } = this.props;
    const qs = queryString.stringify({
      ...url.query,
      fundId: productId,
    });
    const path = `/save?${qs}`;
    this.setState({
      startFlow: true,
      selectedFund: { ...selectedFund, id: productId },
      query: {
        fundId: productId,
      },
    });
    this.trackingLabel += `_${fundType}`;
    handleTrack({
      label: `${this.trackingLabel}_${id}_${fundName}`,
      url: path,
    });
    Router.pushRoute(path, path, { shallow: true });
  };

  private navigateToFundPage = (fundItem: any, id?: string) => {
    const { fundMetaData, fundType, planType = 'GROWTH' } = fundItem;
    if (fundMetaData) {
      const { slug, parentSlug, isinCode, fundName } = fundMetaData;
      const href = `/mutual-funds/${parentSlug}/${slug}/${isinCode}?ref=top-funds-${id}&planType=${planType}`;
      handleTrack({
        label: `${this.trackingLabel}_${id}_${fundType}_${fundName}`,
        url: href,
      });
      Router.pushRoute(href, href, { shallow: true });
    }
  };

  public render() {
    const bucketArray = bucketLists.map((bucket) =>
      bucket.cards ? bucket.cards : bucket.card
    );
    const buckets = Array.prototype.concat
      .apply([], bucketArray)
      .map((bucket) => {
        const {
          title,
          benefits,
          amount,
          bucketId,
          rating,
          actionButton,
          funds,
          duration,
          planSummary,
        } = bucket;
        return {
          title,
          duration,
          amount,
          bucketId,
          rating,
          actionButton,
          benefits,
          funds,
          planSummary,
        };
      });

    const { query, selectedFund, startFlow, nfos } = this.state;
    const { fundId, detailsSlug } = query;
    const isStartFlow = (fundId || detailsSlug) && selectedFund && startFlow;
    const { addFundToCompare, userInfo, pendingActions, transactionData } =
      this.props;
    const variant = VARIANT_VALUES.B;

    return (
      <div>
        <div>
          <TopBlackBanner />
          {/* <TopDeclarationBanner /> */}
        </div>
        <div className={styles['background']}>
          <div className={cx('row')} id="top-fold-header">
            <BannerOne
              pendingActions={pendingActions}
              transactionData={transactionData}
            />
          </div>

          <MobileNav items={MOBILE_NAV_DATA} />
          {isStartFlow ? (
            <InvestFlowHandler
              {...{ ...this.props }}
              onDismiss={this.dismissModal}
              selectedFund={selectedFund}
              sourceType="top-funds"
              redirectUrl={`/save`}
              trackLabel={this.trackingLabel}
            />
          ) : null}
          <div className={'row'}>
            <div
              className={cx(
                'column medium-10 medium-offset-1 large-8 large-offset-2 mb40'
              )}
            >
              <HomeSearch
                fullWidth={true}
                variant={variant}
                placeholder={'Search from over 800+ Mutual Funds'}
              />
            </div>
          </div>
          <div className={cx('hide')}>
            <Sidebar items={SIDEBAR_DATA_MOBILE} />
          </div>
          <div className={cx('row')}>
            <div id="top-plans" className="top-plans-block">
              <TopPlanCards
                sections={SECTIONS}
                buckets={buckets}
                url={this.props.url}
              />
            </div>
            <div
              id="top-funds"
              className={cx(
                'column small-12 top-funds-block',
                styles['plans-by-category']
              )}
            >
              {SECTIONS.map((section) => (
                <Section
                  {...section}
                  {...this.state}
                  onTabClick={this.onTabClick}
                  buckets={buckets}
                  startInvestment={this.startInvestment}
                  handleRowClick={this.navigateToFundPage}
                  key={section.id}
                  addFundToCompare={addFundToCompare}
                  variant={variant}
                />
              ))}
            </div>
          </div>
          {/* Hiding instead of removing since it has dependency of sideBar component */}
          <div className={cx('hide')}>
            <RequestCallback isHomePage userInfo={userInfo} />
          </div>
          {nfos && nfos.length > 0 && (
            <div className="row">
              <div className="large-12 columns">
                <NfoSection nfos={nfos} />
              </div>
            </div>
          )}
          <div className={cx(styles.spacer, 'desktop-only')} />
          <div className="row desktop-only">
            <div className="large-12 columns">
              <WhyUsSection />
              <ResourceList />
              <Featured />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppLayout(
  {
    disableElevClick: true,
    showHeaderNavLinks: true,
    canonicalUrl: 'https://cleartax.in/mutual-funds',
  },
  withCompareWidget(HomeOld)
);



// WEBPACK FOOTER //
// ./pages/index.tsx